import React from 'react';
import { strings } from 'src/localization';
import * as css from './DepartmentContactInfo.module.scss';

interface IProps {
    contactPhone: string;
    extension?: string;
}


export const DepartmentContactInfo = (props: IProps) => {
    const match = props.contactPhone.match(/^(1|)?(\d{3})?(\d{3})(\d{4})$/);
    let phone = '';

    if (match) {
        const intlCode = match[1] ? match[1] + '-' : '';
        const areaCode = match[2] ? match[2] + '-' : '';
        phone = `${intlCode}${areaCode}${match[3]}-${match[4]}`;
    }

    return (
        <>
            <a href={'tel:' + props.contactPhone} className={css.contactInfo} target='hidden-iframe'>
                {phone}
            </a>
            {props.extension && <span>{` ${strings.ext} ${props.extension}`}</span>}
            <span>.</span>
        </>
    );
};
